import React, {Component} from 'react'
import styles from './SelectedLayer.css'
import {LAYOUT_TYPE_HORIZONTAL, LAYOUT_TYPE_VERTICAL} from './Scheduler'
import SchedulerContext from './SchedulerContext'

import control from '../../../assets/img/left-control.png'
import close from '../../../assets/img/clear-selection-icn.png'

export default class SelectedLayer extends Component {
  state = {
    isShow: false,
    options: {},
    top: 0,
    left: 0,
    width: 0,
    height: 0
  }

  clickLeftMove = false
  clickRightMove = false
  firstSelect = false
  lastElement = false
  selectedTimes = {
    start: -1,
    end: -1
  }
  rowDate = null

  multiSelectStart = options => {
    disableScroll()
    this.selectedTimes = options.selectedTimes
    this.rowDate = options.row
    this.rowConfig = options.rowConfig
    switch (this._context.layout) {
      case LAYOUT_TYPE_HORIZONTAL:
        this.horizontalSelectedStart(options)
        break
      case LAYOUT_TYPE_VERTICAL:
        this.verticalSelectStart(options)
        break
    }
  }

  verticalSelectStart = options => {
    let top
    let height
    const {start, end} = options.selectedTimes
    const countCell = (end - start) * 2 + 1

    if (countCell > 1) {
      let startCell = 0
      for (let i = start; i <= end; i = i + 0.5) {
        if (i === options.cell) break
        startCell++
      }
      top = options.htmlCell.offsetTop - startCell * 30
      height = countCell * 31
    } else {
      top = options.htmlCell.offsetTop - 1
      height = 31
    }

    this.setState({
      isShow: true,
      top: top,
      left: options.htmlCell.offsetLeft,
      height: height
    })
  }

  horizontalSelectedStart = options => {
    let left
    let width
    const {start, end} = options.selectedTimes
    const countCell = (end - start) * 2 + 1

    if (countCell > 1) {
      let startCell = 0
      for (let i = start; i <= end; i = i + 0.5) {
        if (i === options.cell) break
        startCell++
      }
      left = options.htmlCell.offsetLeft - startCell * 60
      width = countCell * 60
    } else {
      left = options.htmlCell.offsetLeft
      width = 60
    }

    this.selectedTimes = options.selectedTimes
    this.rowDate = options.row
    this.setState({
      isShow: true,
      top: options.htmlCell.offsetTop + 1,
      left: left,
      width: width
    })
  }

  resizeMove = (posX, posY) => {
    switch (this._context.layout) {
      case LAYOUT_TYPE_HORIZONTAL:
        this._resizeHorizontalMove(posX)
        break
      case LAYOUT_TYPE_VERTICAL:
        this._resizeVerticalMove(posY)
        break
    }
  }

  _resizeVerticalMove = posY => {
    const {top, height} = this.state

    if (this.firstSelect) {
      this.setState({
        height: 31
      })
    }

    if (this.clickRightMove) {
      const nextHeight = posY - top
      this.setState({
        height: nextHeight - 50
      })
    }

    if (this.clickLeftMove) {
      const nextHeight = top - posY + height
      this.setState({
        top: posY - 50,
        height: nextHeight + 50
      })
    }
  }

  _resizeHorizontalMove = posX => {
    const {left, width} = this.state

    if (this.firstSelect) {
      const endElmPosX = left + width
      const nextWidth = width + (posX - endElmPosX)
      this.setState({
        width: nextWidth < 60 ? 60 : nextWidth
      })

      // APP-5748 Force user to tap a cell before dragging.
      this.firstSelect = false
      return
    }

    if (this.clickRightMove) {
      const endElmPosX = left + width
      const nextWidth = width + (posX - endElmPosX)
      this.lastElement = this.props.widthScheduler <= endElmPosX + 60
      this.setState({
        width: nextWidth
      })
    }
    if (this.clickLeftMove) {
      if (posX <= 153) {
        return
      }
      const nextWidth = width + (left - posX)
      this.setState({
        width: nextWidth,
        left: posX
      })
    }
  }

  onMouseDownLeft = () => {
    this.clickLeftMove = true
  }

  onMouseDownRight = () => {
    disableScroll()
    this.clickRightMove = true
  }

  onMouseUpLeft = () => {
    if (!this.clickLeftMove) {
      return
    }

    enableScroll()
    this.clickLeftMove = false

    switch (this._context.layout) {
      case LAYOUT_TYPE_HORIZONTAL:
        this.mouseUpLeftHorizontal()
        break
      case LAYOUT_TYPE_VERTICAL:
        this.mouseUpLeftVertical()
        break
    }
  }

  mouseUpLeftVertical = () => {
    const {top, height} = this.state
    if (height < 30) {
      this.setState({
        height: 30,
        top: top - (30 - height)
      })
      this.props.updateSelected(
        {
          start: this.selectedTimes.start,
          end: this.selectedTimes.start
        },
        this.rowDate
      )
      return
    }

    const movedHeight = height % 30
    const nextHeight =
      movedHeight < 15 ? height - movedHeight : height + (30 - movedHeight)

    const time =
      this.selectedTimes.end - +(parseInt(nextHeight / 30) * 0.5 - 0.5)

    if (
      time >= this._context.workDates.start &&
      this.rowConfig.busy.length !== 0
    ) {
      for (let i = 0; i < this.rowConfig.busy.length; i++) {
        const busyTime = this.rowConfig.busy[i]
        if (time < busyTime.end && time >= busyTime.start) {
          const prevHeight =
            (this.selectedTimes.end - busyTime.end + 0.5) * 2 * 30
          const prevTop = top + (height - prevHeight)
          this.setState({
            height: prevHeight,
            top: prevTop
          })
          this.selectedTimes.start = busyTime.end
          this.props.updateSelected(
            {
              start: this.selectedTimes.start,
              end: this.selectedTimes.end
            },
            this.rowDate
          )
          return
        }
      }
    }

    if (time < this._context.workDates.start) {
      const prevHeight =
        (this.selectedTimes.end - this._context.workDates.start + 0.5) * 2 * 30

      const prevTop = top + (height - prevHeight)
      this.setState({
        height: prevHeight,
        top: prevTop
      })
      this.selectedTimes.start = this._context.workDates.start
      this.props.updateSelected(
        {
          start: this.selectedTimes.start,
          end: this.selectedTimes.end
        },
        this.rowDate
      )
      return
    }

    this.setState({
      height: nextHeight,
      top: movedHeight < 15 ? top + movedHeight : top - (30 - movedHeight)
    })

    this.selectedTimes.start = time
    this.props.updateSelected(
      {
        start: this.selectedTimes.start,
        end: this.selectedTimes.end
      },
      this.rowDate
    )
  }

  mouseUpLeftHorizontal = () => {
    const {width, left} = this.state

    if (width < 60) {
      this.props.updateSelected(
        {
          start: this.selectedTimes.end,
          end: this.selectedTimes.end
        },
        this.rowDate
      )
      this.setState({
        width: 60,
        left: left - (60 - width)
      })
      return
    }

    const movedWidth = width % 60
    const nextWidth =
      movedWidth < 30 ? width - movedWidth : width + (60 - movedWidth)

    const time =
      this.selectedTimes.end - +(parseInt(nextWidth / 60) * 0.5 - 0.5)

    if (
      time >= this._context.workDates.start &&
      this.rowConfig.busy.length !== 0
    ) {
      for (let i = 0; i < this.rowConfig.busy.length; i++) {
        const busyTime = this.rowConfig.busy[i]
        if (time < busyTime.end && time > busyTime.start) {
          const prevWidth =
            (this.selectedTimes.end - busyTime.end + 0.5) * 2 * 60
          const prevLeft = left + (width - prevWidth)
          this.setState({
            width: prevWidth,
            left: prevLeft
          })
          this.selectedTimes.start = busyTime.end
          this.props.updateSelected(
            {
              start: this.selectedTimes.start,
              end: this.selectedTimes.end
            },
            this.rowDate
          )
          return
        }
      }
    }

    this.selectedTimes.start = time
    this.props.updateSelected(
      {
        start: this.selectedTimes.start,
        end: this.selectedTimes.end
      },
      this.rowDate
    )

    this.setState({
      width:
        nextWidth -
        (this.selectedTimes.end - this.selectedTimes.start + 0.5) * 2,
      left:
        (movedWidth < 30 ? left + movedWidth : left - (60 - movedWidth)) +
        (this.selectedTimes.end - this.selectedTimes.start + 0.5) * 2
    })
  }

  onMouseUpRight = () => {
    if (!this.clickRightMove) {
      return
    }
    enableScroll()
    this.clickRightMove = false

    switch (this._context.layout) {
      case LAYOUT_TYPE_HORIZONTAL:
        this.mouseUpRightHorizontal()
        break
      case LAYOUT_TYPE_VERTICAL:
        this.mouseUpRightVertical()
        break
    }
  }

  mouseUpRightVertical = () => {
    const {top, height} = this.state
    if (height < 30) {
      this.setState({
        height: 30
      })
      this.props.updateSelected(
        {
          start: this.selectedTimes.start,
          end: this.selectedTimes.start
        },
        this.rowDate
      )
      return
    }
    const movedHeight = height % 30
    const nextHeight =
      movedHeight < 15 ? height - movedHeight : height + (30 - movedHeight)

    const time =
      this.selectedTimes.start + (parseInt(nextHeight / 30) * 0.5 - 0.5)

    if (
      time <= this._context.workDates.end &&
      this.rowConfig.busy.length !== 0
    ) {
      for (let i = 0; i < this.rowConfig.busy.length; i++) {
        const busyTime = this.rowConfig.busy[i]
        if (
          this.selectedTimes.start < busyTime.start &&
          time >= busyTime.start
        ) {
          const prevHeight =
            (busyTime.start - this.selectedTimes.start) * 2 * 30
          this.setState({
            height: prevHeight,
            top: top
          })
          this.selectedTimes.end = busyTime.start - 0.5
          this.props.updateSelected(
            {
              start: this.selectedTimes.start,
              end: this.selectedTimes.end
            },
            this.rowDate
          )
          return
        }
      }
    }

    if (time > this._context.workDates.end) {
      const prevHeight =
        (this._context.workDates.end - this.selectedTimes.start + 1) * 2 * 30
      this.setState({
        height: prevHeight,
        top: top
      })
      this.selectedTimes.end = this._context.workDates.end
      this.props.updateSelected(
        {
          start: this.selectedTimes.start,
          end: this.selectedTimes.end
        },
        this.rowDate
      )
      return
    }

    this.setState({
      height: nextHeight + (this.selectedTimes.end - this.selectedTimes.start)
    })
    this.selectedTimes.end = time
    this.props.updateSelected(
      {
        start: this.selectedTimes.start,
        end: this.selectedTimes.end
      },
      this.rowDate
    )
  }

  mouseUpRightHorizontal = () => {
    let width = this.state.width
    if (width < 60) {
      this.setState({
        width: 60
      })
      this.props.updateSelected(
        {
          start: this.selectedTimes.start,
          end: this.selectedTimes.start
        },
        this.rowDate
      )
      return
    }
    const movedWidth = width % 60
    const endPosX = this.state.left + width
    const sc = this.props.widthScheduler
    if (sc <= endPosX) {
      this.setState({
        width: sc - this.state.left
      })
      return
    }
    const nextWidth =
      movedWidth < 30 ? width - movedWidth : width + (61 - movedWidth)

    const time =
      this.selectedTimes.start + (parseInt(nextWidth / 60) * 0.5 - 0.5)
    if (
      time <= this._context.workDates.end &&
      this.rowConfig.busy.length !== 0
    ) {
      for (let i = 0; i < this.rowConfig.busy.length; i++) {
        const busyTime = this.rowConfig.busy[i]
        if (
          this.selectedTimes.start < busyTime.start &&
          time >= busyTime.start
        ) {
          const prevWidth = (busyTime.start - this.selectedTimes.start) * 2 * 60
          this.setState({
            width: prevWidth
          })
          this.selectedTimes.end = busyTime.start - 0.5
          this.props.updateSelected(
            {
              start: this.selectedTimes.start,
              end: this.selectedTimes.end
            },
            this.rowDate
          )
          return
        }
      }
    }

    this.selectedTimes.end = time

    this.props.updateSelected(
      {
        start: this.selectedTimes.start,
        end: this.selectedTimes.end
      },
      this.rowDate
    )
    this.setState({
      width:
        nextWidth -
        (this.selectedTimes.end - this.selectedTimes.start + 0.5) * 2
    })
  }

  onRemoveSelected = () => {
    this.props.onRemoveSelected(this.rowDate)
    this.setState({
      isShow: false
    })
  }

  hide = () => {
    this.setState({
      isShow: false
    })
  }

  _renderContent = values => {
    this._context = values

    switch (values.layout) {
      case LAYOUT_TYPE_VERTICAL:
        return this._renderVerticalView()
      case LAYOUT_TYPE_HORIZONTAL:
        return this._renderHorizontalView()
    }
  }

  _renderVerticalView = () => {
    const {isShow, top, left, height} = this.state
    const containerStyle = {
      display: isShow ? 'block' : 'none',
      top: top,
      left: left,
      width: 'calc(100% - 120px)',
      height: height
    }
    return (
      <div
        style={containerStyle}
        className={styles.containerVertical}
        onDragStart={() => {
          return false
        }}
      >
        <div
          key={2}
          className={styles.mainSelectCellClose}
          style={{marginLeft: -40}}
          onClick={this.onRemoveSelected}
        >
          <img src={close} />
        </div>
        <div style={{width: '100%', height: '50%'}}>
          <div className={styles.pathVertical} />
          <img
            draggable={false}
            src={control}
            className={styles.imgVertical}
            onMouseDown={this.onMouseDownLeft}
            onMouseUp={this.onMouseUpLeft}
            onTouchStart={this.onMouseDownLeft}
            onTouchEnd={this.onMouseUpLeft}
            onDragStart={() => false}
          />
        </div>
        <div style={{width: '100%', height: '50%'}}>
          <div
            className={styles.pathVertical}
            style={{top: height, position: 'absolute'}}
          />
          <img
            draggable={false}
            src={control}
            className={styles.imgVertical}
            style={{top: height - 11}}
            onMouseDown={this.onMouseDownRight}
            onMouseUp={this.onMouseUpRight}
            onTouchStart={this.onMouseDownRight}
            onTouchEnd={this.onMouseUpRight}
          />
        </div>
      </div>
    )
  }

  onNotEvent = () => false

  _renderHorizontalView = () => {
    const {isShow, top, left, width} = this.state
    const containerStyle = {
      display: isShow ? 'flex' : 'none',
      top: top,
      left: left,
      width: width,
      height: 60
    }

    return (
      <div
        style={containerStyle}
        className={styles.container}
        onDragStart={() => {
          return false
        }}
      >
        {this.lastElement && (
          <div
            key={2}
            className={styles.mainSelectCellClose}
            style={{marginLeft: -40}}
            onClick={this.onRemoveSelected}
          >
            <img src={close} />
          </div>
        )}
        <div
          key={0}
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            width: '50%'
          }}
        >
          <div className={styles.mainSelectCellPath} />
          <img
            draggable={false}
            src={control}
            className={styles.mainSelectCellImg}
            style={{left: -10, top: 20}}
            onMouseDown={this.onMouseDownLeft}
            onMouseUp={this.onMouseUpLeft}
            onTouchStart={this.onMouseDownLeft}
            onTouchEnd={this.onMouseUpLeft}
          />
        </div>
        <div
          key={1}
          style={{display: 'flex', justifyContent: 'flex-end', width: '50%'}}
          onDragStart={this.onNotEvent}
          onDragEnter={this.onNotEvent}
          onDrag={this.onNotEvent}
          onDragLeave={this.onNotEvent}
          onDragOver={this.onNotEvent}
        >
          <img
            draggable={false}
            src={control}
            className={styles.mainSelectCellImg}
            style={{left: 10, top: 20}}
            onMouseDown={this.onMouseDownRight}
            onMouseUp={this.onMouseUpRight}
            onTouchStart={this.onMouseDownRight}
            onTouchEnd={this.onMouseUpRight}
          />

          <div className={styles.mainSelectCellPath} />
        </div>
        {!this.lastElement && (
          <div
            key={2}
            className={styles.mainSelectCellClose}
            style={{marginLeft: width + 10}}
            onClick={this.onRemoveSelected}
          >
            <img src={close} />
          </div>
        )}
      </div>
    )
  }

  render() {
    return (
      <SchedulerContext.Consumer>
        {values => this._renderContent(values)}
      </SchedulerContext.Consumer>
    )
  }
}

const isPlatformIOS = () =>
  !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

function preventDefault(e) {
  e = e || window.event
  if (e.preventDefault) {
    e.preventDefault()
  }
  e.returnValue = false
}

export function disableScroll() {
  if (window.addEventListener) {
    // older FF
    window.addEventListener('DOMMouseScroll', preventDefault, false)
  }
  window.onwheel = preventDefault // modern standard
  window.onmousewheel = document.onmousewheel = preventDefault // older browsers, IE
  window.ontouchmove = preventDefault // mobile

  if (isPlatformIOS()) {
    document.ontouchmove = function(e) {
      e.preventDefault()
    }
  }
}

export function enableScroll() {
  if (window.removeEventListener) {
    window.removeEventListener('DOMMouseScroll', preventDefault, false)
  }
  window.onmousewheel = document.onmousewheel = null
  window.onwheel = null
  window.ontouchmove = null

  if (isPlatformIOS()) {
    document.ontouchmove = function(e) {
      return true
    }
  }
}
